// extracted by mini-css-extract-plugin
export default {"formButtons":"SetUpProduct_formButtons__klhre","checkboxClassName":"SetUpProduct_checkboxClassName__-eC7o","formButton":"SetUpProduct_formButton__e+bIq"};